import React, { useEffect, useState } from "react";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";

import axios from "axios";
import loadConfig from "../../../Services/Api/ApiServices";
import { useParams } from "react-router-dom";

import LoaderAHSF from "../../../Components/LoaderAHSF";
import { GetOneInformationAboutTheScientificFoundation } from "../../../Redux/Reducers/Submitter/InformationAboutScientificInstitution";
import { decryptToken } from "../../../Services/Encryption/EncryptionParams";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import AttachmentsAHSF from "../../../Components/AttachmentsAHSF";
import {
  GetAttachmentsByPermissions,
  SetAttachments,
} from "../../../Redux/Reducers/Submitter/Attachments";
function Attachments(props) {
  const AppGuid = useParams();
  const [attachments, setAttachments] = useState([]);
  const [refreshData, setrefreshData] = useState(false);
  const [dataJsonObject, SetDataJsonObject] = useState();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      InfoScientificFoundation:
        state.InformationAboutScientificInstitution.InfoScientificFoundation,
      Attachments: state.Attachments.Attachments,
      loadingAttachments: state.Attachments.loadingAttachments,
    };
  });
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
  };

  useEffect(() => {
    dataJson();
  }, []);
  //[,]
  //to get BeneficiaryInformation data by guid from localstorge or params
  useEffect(() => {
    dispatch(
      GetOneInformationAboutTheScientificFoundation({
        applicationInformationId:
          localStorage.getItem("ApplicationInformationId") ||
          props.applicationGuid,
      })
    );
  }, []);

  useEffect(() => {
    if (state.InfoScientificFoundation) {
      dispatch(
        GetAttachmentsByPermissions({
          sectorId: state.InfoScientificFoundation.sectorId,
          applicationInformationId:
            localStorage.getItem("ApplicationInformationId") ||
            props.applicationGuid,
        })
      );
    }
  }, [state.InfoScientificFoundation, refreshData]);
  // Update the local state `attachments` with the current attachments from Redux state
  useEffect(() => {
    if (state.loadingAttachments && state.Attachments) {
      setAttachments([...state.Attachments]);
    }
  }, [state.loadingAttachments, state.Attachments]);
  //   // Dispatch the current attachments from the local state to Redux
  //   useEffect(() => {
  //     dispatch(SetAttachments([...attachments]));
  //   }, [attachments]);
  console.log(state.Attachments, "Attachments");
  return state.Attachments ? (
    <>
      <SharedDiv
        showTitle={true}
        titleName="المرفقات والتعهد"
        child={
          state.Attachments && state.Attachments.length != 0 ? (
            state.Attachments.map((attachment, index) => (
              <div className="form-grid" key={attachment.id}>

                <p>
                  {attachment.sU_NT_AAP_AttachementTypes.attachementName}
                 {attachment.sU_NT_AAP_AttachementTypes?.folderName =="other"?
                <p className="massageA">{dataJsonObject?.AttachmentMassage}</p>:""}
                {attachment.isRequierd && <span className="star">* </span>}
                </p>

                <AttachmentsAHSF
                  id={`file${index}`}
                  //   text={attachment.sU_NT_AAP_AttachementTypes.folderName}
                  // title={attachment.aC_AttachementTypes.attachementName}
                  // text={"انقر لتعديل المرفق"}
                  title={"انقر لتعديل المرفق"}
                  //   disabled={shouldDisableFields}
                  disabled={props.shouldDisableFields}
                  show={props.shouldDisableFields ? false : true}
                  clear={false}
                  readOnly={false}
                  singleFile={attachment.attachmentData}
                  AttachementType={
                    attachment.sU_NT_AAP_AttachementTypes?.folderName
                  }
                  onChange={(e) => {
                    //console.log(e.target.files[0],"fileeeeeeeeeeeeeee");

                    // UpdateAttachments({
                    //   file: e.target.files[0],
                    //   fileName: attachment.aC_AttachementTypes.folderName,
                    //   aC_AttachementTypesId: attachment.aC_AttachementTypesId,
                    //   aI_ApplicationInformationId:
                    //     attachment.aI_ApplicationInformationId,
                    // });

                    // setLoading(true)
                    // setrefreshData(false);

                    axios
                      .post(
                        `${dataJsonObject.domainUrl}/api/Attachments/UpdateAttachments`,
                        {
                          file: e.target.files[0],
                          fileName:
                            attachment.sU_NT_AAP_AttachementTypes.folderName,
                          attachementTypesId: attachment.attachementTypesId,
                          applicationInformationId:
                            attachment.applicationInformationId,
                        },
                        {
                          headers: {
                            "Content-Type": "multipart/form-data",
                          },
                        }
                      )
                      .then((res) => {
                        // console.log(res, "RESSSSSSSSSSSSSSSSSSSSS");
                        if (res.data.success) {
                          setLoading(false);
                        }
                        // setrefreshData(true);
                      })
                      .catch((err) => {
                        //console.log(err);
                      });
                  }}
                />
              </div>
              
            ))
          ) : (
            <div className="form-nothing">لا يوجد مرفقات</div>
          )
        }
      />
      {/* <LoaderAHSF
        show={
          loading ||
          state.Attachments == "undefined" ||
          state.Attachments == undefined ||
          !state.Attachments?.length
        }
      /> */}
    </>
  ) : (
    ""
  );
}

export default Attachments;
